import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, ButtonBase } from '@mui/material';
import { CATEGORY_IMAGES, type CategorySlug } from '../../assets/categoryImages';

// Stable hand-tuned mosaic — 12 cells across 4 columns / 3 rows on desktop.
// Each entry pulls one image from a category folder by index.
const MOSAIC: Array<{ slug: CategorySlug; index: number }> = [
  { slug: 'hair', index: 0 },
  { slug: 'cake', index: 0 },
  { slug: 'makeup', index: 1 },
  { slug: 'nail', index: 0 },
  { slug: 'fashion', index: 1 },
  { slug: 'food', index: 0 },
  { slug: 'event', index: 0 },
  { slug: 'hair', index: 2 },
  { slug: 'cake', index: 2 },
  { slug: 'makeup', index: 3 },
  { slug: 'nail', index: 2 },
  { slug: 'event', index: 2 },
];

export function InspirationMosaic() {
  const navigate = useNavigate();

  const tiles = useMemo(
    () =>
      MOSAIC.map(({ slug, index }) => {
        const list = CATEGORY_IMAGES[slug];
        if (!list || list.length === 0) return null;
        return { url: list[index % list.length], slug };
      }).filter(Boolean) as Array<{ url: string; slug: CategorySlug }>,
    [],
  );

  return (
    <Box
      sx={{
        display: 'grid',
        gap: { xs: 1, sm: 1.25 },
        gridTemplateColumns: {
          xs: 'repeat(2, 1fr)',
          sm: 'repeat(3, 1fr)',
          md: 'repeat(4, 1fr)',
        },
      }}
    >
      {tiles.map((tile, i) => (
        <ButtonBase
          key={`${tile.slug}-${i}`}
          onClick={() => navigate('/search')}
          sx={{
            position: 'relative',
            display: 'block',
            borderRadius: 2.5,
            overflow: 'hidden',
            aspectRatio: i % 5 === 0 ? '3 / 4' : '1 / 1',
            '&:hover img': { transform: 'scale(1.06)' },
            '&:hover .mosaic-overlay': { opacity: 0.25 },
          }}
        >
          <Box
            component="img"
            src={tile.url}
            alt=""
            loading="lazy"
            sx={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transition: 'transform 500ms ease',
            }}
          />
          <Box
            className="mosaic-overlay"
            sx={{
              position: 'absolute',
              inset: 0,
              bgcolor: 'common.black',
              opacity: 0,
              transition: 'opacity 250ms ease',
            }}
          />
        </ButtonBase>
      ))}
    </Box>
  );
}
